var $c111b245b4961c2e$exports = {};
$c111b245b4961c2e$exports = {
    "endTime": `Biti\u{15F} saati`,
    "startTime": `Ba\u{15F}lang\u{131}\xe7 saati`,
    "time": `Saat`
};


export {$c111b245b4961c2e$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
